import S3 from "aws-sdk/clients/s3";

const s3 = new S3({
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
  },
  region: process.env.REACT_APP_AWS_S3_REGION
});
export const uploadMedia = async (
  body,
  mime_type,
  user_id,
  object_url,
  progress_cb
) => {
  try {
    var params = {
      Bucket: process.env.REACT_APP_AWS_CLIENT_BUCKET,
      Body: body,
      Key: object_url,
      ContentType: mime_type,
      Metadata: {
        user_id: user_id.toString()
      }
    };
    var putObjectPromise = s3
      .putObject(params)
      .on("httpUploadProgress", progress_cb)
      .promise();
    await putObjectPromise;
  } catch (error) {
    throw error;
  }
};
